module.exports = __webpack_public_path__ + "officialStatic/img/pf2.6de337f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/pf2.png
// module id = FgKf
// module chunks = 0